/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import * as Util from "../../../util"
import { ChatCloseIcon } from "./_chatCloseIcon"
import { ChatUserName } from "./_chatUserName"
import { ChatMessageText } from "./_chatMessageText"
import { UserAvatar } from "../../common/avatar"
import { localUserStaticPropsAtom } from "../../../recoil/atoms/users"
import { brandingSelector } from "../../../recoil/atoms/room"
import { addHitAreaStyle } from "../../../util/styleUtils"
import { MessageModel } from "src/recoil/atoms/chats/types"


const SelectedMessage = ({ chat, handleClose, isMobile, isTransparent }: {
  chat: Partial<MessageModel>
  handleClose: (args?: unknown) => unknown
  isMobile: boolean
  isTransparent: boolean
}) => {
  const localUserProps = useRecoilValue(localUserStaticPropsAtom)
  const styleschat = useRecoilValue(brandingSelector)

  const localUserName = localUserProps?.name
  const localUserId = localUserProps?.id

  const backgroundColor = React.useMemo(() => {
    if (isTransparent) {
      return "none"
    }

    return styleschat?.servicePanelElementBackground ?? "white"
  }, [isTransparent])

  const colorDisk = chat?.author?.color

  const borderColor = React.useMemo(() => {
    return styleschat?.servicePanelElementBorder
      ? styleschat?.servicePanelElementBorder
      : "#E2E8F0"
  }, [styleschat?.servicePanelElementBorder])

  const avatarStyles = React.useMemo(() => {
    return { width: "1.5rem", height: "1.5rem" }
  }, [])

  return (
    <Box
      bgColor={isTransparent ? "rgba(0, 0, 0, 0.5)" : backgroundColor}
      id={`message-${chat?.id}`}
      key={`message-${chat?.id}-key`}
      marginTop="2"
      sx={{
        p: isTransparent ? "0.2rem 0rem" : "0.2rem"
      }}
      borderRadius="0.6rem"
      borderWidth={isTransparent ? "0px" : "2px"}
      borderStyle="solid"
      borderColor={borderColor}
      pos="relative"
      display="flex"
      width="100%"
      minWidth={isMobile && "70px"}
      flexDirection={"column"}
    >
      <Flex
        textColor="gray"
        pos="relative"
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
      >
        <Flex flexDirection="column">
          <Flex
            marginLeft={isTransparent ? "0.33rem" : "0.1rem"}
            marginTop="0.1rem"
          >
            <UserAvatar
              avatar={chat?.author?.avatar}
              avatarStyle={avatarStyles}
              name={chat?.author?.name}
              size="xs"
              src={chat?.author?.avatar}
              colorDisk={colorDisk}
            />
          </Flex>
        </Flex>

        <Flex
          flexDirection="column"
          width="75%"
          marginLeft="0.33rem"
          marginRight={isMobile && "0.33rem"}
        >
          <ChatUserName
            isMobile={isMobile}
            styleschat={styleschat}
            isTransparent={isTransparent}
            isModerator={false}
            isPrivateMessage={false}
            author={chat?.author}
            targetUser={chat?.targetUser}
            localUserName={localUserName}
            localUserId={localUserId}
            message={chat?.message}
            hovered={false}
          />
          {chat?.message && (
            <ChatMessageText
              styleschat={styleschat}
              isMobile={isMobile}
              hovered={false}
              message={chat?.message}
              isApproved={false}
              isTransparent={isTransparent}
              textStyle={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%"
              }}
            />
          )}
        </Flex>

        <Flex>
          {!isTransparent && (
            <Flex
              wordBreak="break-word"
              textColor={styleschat?.commentTextColor ?? "inherit"}
              fontFamily={styleschat?.commentFontFamily ?? "inherit"}
              flexDirection="column"
            >
              <Box position={"relative"}>
                <Flex
                  marginTop="auto"
                  marginBottom="0.1rem"
                  onClick={() => handleClose()}
                  // increase hit area
                  {...addHitAreaStyle({ top: 12, right: 12, bottom: 8 })}
                >
                  <ChatCloseIcon
                    styleschat={styleschat}
                    isMobile={isMobile}
                    callback={() => handleClose()}
                  />
                </Flex>
              </Box>
              <Flex
                whiteSpace="nowrap"
                marginLeft={isMobile ? "auto" : "0.25rem"}
              >
                <Text
                  fontSize="0.75rem"
                  color={styleschat?.servicePanelElementLabels ?? "#718096"}
                >
                  {Util.formatTime24h(chat?.timestamp)}
                </Text>
              </Flex>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Box>
  )
}

export default SelectedMessage
